import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import ProcessManager from '../../../Common/Managers/ProcessManager';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

class Footer extends Component {
    constructor(props) {
        super(props)
    }

    handleClick(tarjetas) {
        if (this.props.empresaSeleccionada && this.props.empresaSeleccionada.Id ) {
            if(tarjetas.tipoEmpresa.EmpresaIndividuos=="I"){
                let tipoEmpresa = this.props.empresaSeleccionada;
                this.props.routeToCuenta(tipoEmpresa);
            }else if(tarjetas.tipoEmpresa.EmpresaIndividuos=="E"){
                this.props.routeToEmpresa();
            }
        }
        else {
            this.props.showError();
        }
    }

    routeToAdministradora() {
        this.props.routeToAdministradora();
    }

    routeToVistaCliente() {
        this.props.routeToVistaCliente();
    }

    render() {
        const { routeToVistaCliente, routeToAdministradora,tarjetas } = this.props;
        let lastButton = <button onClick={() => this.routeToAdministradora()} className="btn btn-secondary">&#60; Anterior</button>
        let cancelButton = <button onClick={() => this.routeToVistaCliente()} className="btn btn-secondary">Cancelar</button>

        return (<div className="row">
            {this.props.permisos.components.BotonesAnteriorSiguiente.Active == true &&
                <div className="col-md-2">
                {lastButton}
                </div>}
            <div className="col-md-4">
                {cancelButton}
            </div>
            <div className="col-md-4">
            </div>
            {this.props.permisos.components.BotonesAnteriorSiguiente.Active == true &&
                <div className="col-md-2">
                    <GenericSimpleButton text="Siguiente > " buttonClass="btn btn-cta" onClick={(event) => this.handleClick(tarjetas)} />
                </div>}
        </div>);
    }
};

export default Footer